import React from "react";
import PeriodSelector from '../periodSelector';
import FiltersWrapper from '../wrappers/filtersWrapper';
import DimensionSelector from '../dimensionSelector';
import FilterBySelector from '../filterBySelector';
import ComparisonSwitch from '../comparisonSwitch';

const FiltersSection = ({ limited = false, dimensions = {}, defaultSelection = 'provider', filterControl}) => {
  return (
    <div className="filters-main-wrapper">
      {/* Always render period selector and filter by*/}
      <FiltersWrapper>
        <PeriodSelector />
      </FiltersWrapper>
      <FiltersWrapper>
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4}}>
          {!limited && <ComparisonSwitch/>}
          {filterControl}
        </div>
      </FiltersWrapper>
      <FilterBySelector />
      {!limited && <DimensionSelector dimensions={dimensions} defaultValue={defaultSelection} fullSize={true}/>}
    </div>
  );
};

export default FiltersSection;